document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initGaleria();
  initVariantes();
  initStickyCta();
  initBundleSelector();
  initCountdown();
  initComparar();
});

function initComparar() {
  document.querySelectorAll('[data-rd-comparar]').forEach(function (wrap) {
    var slider = wrap.querySelector('[data-rd-comparar-slider]');

    function setPos(pct) {
      pct = Math.max(0, Math.min(100, pct));
      wrap.style.setProperty('--rd-comparar-pos', pct + '%');
      if (slider) slider.value = pct;
    }

    function posFromEvent(e) {
      var rect = wrap.getBoundingClientRect();
      var x = e.clientX - rect.left;
      return (x / rect.width) * 100;
    }

    var arrastrando = false;

    wrap.addEventListener('pointerdown', function (e) {
      arrastrando = true;
      if (wrap.setPointerCapture) wrap.setPointerCapture(e.pointerId);
      setPos(posFromEvent(e));
    });
    wrap.addEventListener('pointermove', function (e) {
      if (!arrastrando) return;
      setPos(posFromEvent(e));
    });
    wrap.addEventListener('pointerup', function () { arrastrando = false; });
    wrap.addEventListener('pointercancel', function () { arrastrando = false; });

    if (slider) {
      slider.addEventListener('input', function () {
        wrap.style.setProperty('--rd-comparar-pos', slider.value + '%');
      });
    }
  });
}

function initCountdown() {
  document.querySelectorAll('[data-rd-countdown]').forEach(function (box) {
    var fecha = box.getAttribute('data-fecha');
    var target = new Date(fecha).getTime();
    if (!fecha || isNaN(target)) { box.style.display = 'none'; return; }

    var diasEl = box.querySelector('[data-rd-countdown-dias]');
    var horasEl = box.querySelector('[data-rd-countdown-horas]');
    var minEl = box.querySelector('[data-rd-countdown-min]');
    var segEl = box.querySelector('[data-rd-countdown-seg]');
    var timer;

    function pad(n) { return String(n).padStart(2, '0'); }

    function tick() {
      var diff = target - Date.now();
      if (diff <= 0) {
        box.style.display = 'none';
        if (timer) clearInterval(timer);
        return;
      }
      var dias = Math.floor(diff / 86400000);
      var horas = Math.floor((diff % 86400000) / 3600000);
      var min = Math.floor((diff % 3600000) / 60000);
      var seg = Math.floor((diff % 60000) / 1000);
      if (diasEl) diasEl.textContent = pad(dias);
      if (horasEl) horasEl.textContent = pad(horas);
      if (minEl) minEl.textContent = pad(min);
      if (segEl) segEl.textContent = pad(seg);
    }

    tick();
    timer = setInterval(tick, 1000);
  });
}

function initBundleSelector() {
  var box = document.querySelector('[data-rd-bundle-selector]');
  if (!box) return;
  var mapEl = box.querySelector('[data-rd-bundle-map]');
  var link = box.querySelector('[data-rd-bundle-link]');
  if (!mapEl || !link) return;
  var map;
  try { map = JSON.parse(mapEl.textContent); } catch (e) { return; }

  var grupos = box.querySelectorAll('[data-rd-bundle-opcion]');

  function actualizar() {
    var color = box.querySelector('[data-rd-bundle-opcion="color"] .is-active').getAttribute('data-valor');
    var spec = box.querySelector('[data-rd-bundle-opcion="spec"] .is-active').getAttribute('data-valor');
    var key = color + '|' + spec;
    if (map[key]) link.setAttribute('href', map[key]);
  }

  grupos.forEach(function (grupo) {
    grupo.querySelectorAll('[data-valor]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        grupo.querySelectorAll('[data-valor]').forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        actualizar();
      });
    });
  });

  actualizar();
}

function initStickyCta() {
  var bar = document.querySelector('[data-rd-sticky-cta]');
  if (!bar) return;
  var threshold = window.innerHeight * 0.7;
  function toggle() {
    if (window.scrollY > threshold) {
      bar.classList.add('is-visible');
    } else {
      bar.classList.remove('is-visible');
    }
  }
  window.addEventListener('scroll', toggle, { passive: true });
  toggle();
}

function initReveal() {
  var items = document.querySelectorAll('.rd-reveal');
  if (!items.length) return;
  if (!('IntersectionObserver' in window)) {
    items.forEach(function (el) { el.classList.add('rd-visible'); });
    return;
  }
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('rd-visible');
        obs.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -60px 0px' });
  items.forEach(function (el) { obs.observe(el); });
}

function initGaleria() {
  document.querySelectorAll('[data-rd-galeria]').forEach(function (galeria) {
    var wrap = galeria.querySelector('[data-rd-galeria-principal-wrap]');
    var minis = galeria.querySelectorAll('[data-rd-galeria-mini]');
    var btnVideo = galeria.querySelector('[data-rd-galeria-ver-video]');
    if (!wrap || !minis.length) return;

    function activar(mini) {
      var tipo = mini.getAttribute('data-tipo');
      var alt = mini.getAttribute('data-alt') || '';
      if (tipo === 'video') {
        var videoSrc = mini.getAttribute('data-video-src');
        var poster = mini.getAttribute('data-poster');
        if (!videoSrc) return;
        wrap.innerHTML = '<video data-rd-galeria-principal playsinline controls autoplay muted loop' +
          (poster ? ' poster="' + poster + '"' : '') +
          ' aria-label="' + alt.replace(/"/g, '&quot;') + '"><source src="' + videoSrc + '" type="video/mp4"></video>';
      } else {
        var full = mini.getAttribute('data-full');
        if (!full) return;
        wrap.innerHTML = '<img data-rd-galeria-principal src="' + full + '" alt="' + alt.replace(/"/g, '&quot;') + '">';
      }
      minis.forEach(function (m) { m.classList.remove('is-active'); });
      mini.classList.add('is-active');
    }

    minis.forEach(function (mini) {
      mini.addEventListener('click', function () { activar(mini); });
    });

    if (btnVideo) {
      var miniVideo = galeria.querySelector('[data-rd-galeria-mini][data-tipo="video"]');
      if (miniVideo) {
        btnVideo.addEventListener('click', function () {
          activar(miniVideo);
          wrap.scrollIntoView({ behavior: 'smooth', block: 'center' });
        });
      } else {
        btnVideo.style.display = 'none';
      }
    }
  });
}

function initVariantes() {
  var form = document.getElementById('rd-producto-form');
  if (!form) return;
  var dataEl = document.querySelector('[data-rd-variantes-json]');
  if (!dataEl) return;
  var variantes;
  try { variantes = JSON.parse(dataEl.textContent); } catch (e) { return; }

  var idInput = form.querySelector('input[name="id"]');
  var precioEl = document.querySelector('[data-rd-precio]');
  var precioAntesEl = document.querySelector('[data-rd-precio-antes]');
  var btnComprar = form.querySelector('[data-rd-btn-comprar]');
  var stockMsg = document.querySelector('[data-rd-stock-agotado]');
  var grupos = document.querySelectorAll('[data-rd-opcion-grupo]');
  var galeriaMinis = document.querySelectorAll('[data-rd-galeria-mini]');

  function moneda(cents) {
    return (cents / 100).toLocaleString(document.documentElement.lang || 'es', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR' });
  }

  function seleccionActual() {
    var sel = [];
    grupos.forEach(function (g) {
      var activo = g.querySelector('.is-active');
      sel.push(activo ? activo.getAttribute('data-valor') : null);
    });
    return sel;
  }

  function actualizar() {
    var sel = seleccionActual();
    var match = variantes.find(function (v) {
      return v.options.every(function (opt, i) { return opt === sel[i]; });
    });
    if (!match) return;
    idInput.value = match.id;
    if (precioEl) precioEl.textContent = moneda(match.price);
    if (precioAntesEl) {
      if (match.compare_at_price && match.compare_at_price > match.price) {
        precioAntesEl.textContent = moneda(match.compare_at_price);
        precioAntesEl.style.display = '';
      } else {
        precioAntesEl.style.display = 'none';
      }
    }
    if (btnComprar) {
      btnComprar.disabled = !match.available;
      btnComprar.textContent = match.available ? btnComprar.getAttribute('data-texto-disponible') : btnComprar.getAttribute('data-texto-agotado');
    }
    if (stockMsg) stockMsg.style.display = match.available ? 'none' : '';

    var galeriaPrincipal = document.querySelector('[data-rd-galeria-principal]');
    if (match.image && galeriaPrincipal && (galeriaPrincipal.tagName !== 'IMG' || galeriaPrincipal.src !== match.image)) {
      if (galeriaPrincipal.tagName !== 'IMG') {
        var img = document.createElement('img');
        img.setAttribute('data-rd-galeria-principal', '');
        img.alt = '';
        galeriaPrincipal.replaceWith(img);
        galeriaPrincipal = img;
      }
      galeriaPrincipal.src = match.image;
      var matched = false;
      galeriaMinis.forEach(function (mini) {
        var esta = mini.getAttribute('data-full') === match.image;
        mini.classList.toggle('is-active', esta);
        if (esta) matched = true;
      });
      if (!matched) galeriaMinis.forEach(function (mini) { mini.classList.remove('is-active'); });
    }
  }

  grupos.forEach(function (grupo) {
    grupo.querySelectorAll('[data-valor]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        grupo.querySelectorAll('[data-valor]').forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        actualizar();
      });
    });
  });

  actualizar();
}
